"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabAnimationContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _AppTabNavigation = _interopRequireDefault(require("../AppTabNavigation"));

var _Matches = _interopRequireDefault(require("../Matches"));

var _Welcome = _interopRequireDefault(require("../Welcome"));

var _LikeSigned = _interopRequireDefault(require("../LikeSigned"));

var _ProfileForm = _interopRequireDefault(require("../ProfileForm"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _MatchesScreen = _interopRequireDefault(require("../MatchesScreen"));

var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _Authentication = require("../../provider/Authentication");

var _Judgements = require("../../provider/Judgements");

var _Matches2 = require("../../provider/Matches");

var _Route = require("../../provider/Route");

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _SearchOutlined = _interopRequireDefault(require("@material-ui/icons/SearchOutlined"));

var _SettingsOutlined = _interopRequireDefault(require("@material-ui/icons/SettingsOutlined"));

var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _LikedMatches = _interopRequireDefault(require("../LikedMatches"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabAnimationContext = /*#__PURE__*/_react.default.createContext(function () {});

exports.TabAnimationContext = TabAnimationContext;

var SearchTab = function SearchTab(_ref) {
  var activeTab = _ref.activeTab;

  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext.user;

  switch (activeTab) {
    case 'likesigned':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LikeSigned.default, {});

    case 'likedDirect':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
          user: user ? user.attributes.name : '',
          newUser: true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MatchesScreen.default, {})]
      });

    case 'home':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Welcome.default, {});

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Matches.default, {});
  }
};

var AppTabs = function AppTabs(_ref2) {
  var _ref2$activeTab = _ref2.activeTab,
      activeTab = _ref2$activeTab === void 0 ? 'search' : _ref2$activeTab;
  var isSearch = !['jobs', 'profile'].includes(activeTab);

  var getSearchTab = function getSearchTab(activeTab, t, amountOfMatches) {
    var tabData = {
      id: isSearch ? activeTab : 'search',
      label: t('pc-matching:AppTabNavigation.search', 'Suche'),
      icon: isSearch ? _SearchOutlined.default : _Search.default,
      component: /*#__PURE__*/(0, _jsxRuntime.jsx)(SearchTab, {
        activeTab: activeTab
      })
    };
    return (0, _extends2.default)({}, tabData, {
      label: t('pc-matching:AppTabNavigation.searchResults', 'Suchergebnisse'),
      badge: {
        value: amountOfMatches,
        // put here the badge value
        status: Number(amountOfMatches) > 0 // put here the badge status

      }
    });
  };

  var getTabs = function getTabs(t, amountOflikes, tabToAnimate, isAuthenticated, activeTab, switchTab, newMatches) {
    return [{
      id: 'profile',
      label: t('pc-matching:AppTabNavigation.profile', 'Profil'),
      icon: activeTab !== 'profile' ? _SettingsOutlined.default : _Settings.default,
      disabled: !isAuthenticated,
      component: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileForm.default, {}),
      className: (0, _Onboarding.targetClassName)('editTab')
    }, getSearchTab(activeTab, t, newMatches), {
      id: 'jobs',
      label: t('pc-matching:AppTabNavigation.jobs', 'Jobs'),
      icon: activeTab !== 'jobs' ? _FavoriteBorder.default : _Favorite.default,
      disabled: !isAuthenticated,
      wrapped: tabToAnimate === 'jobs',
      component: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LikedMatches.default, {
        switchTab: switchTab
      }),
      badge: {
        value: amountOflikes,
        // put here the badge value
        status: true // put here the badge status

      }
    }];
  };

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext2 = (0, _react.useContext)(_Judgements.JudgementsContext),
      userLikes = _useContext2.userLikes;

  var _useContext3 = (0, _react.useContext)(_Matches2.MatchesContext),
      newMatches = _useContext3.newMatches;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tabToAnimate = _useState2[0],
      setAnimateTab = _useState2[1];

  var _useTooltipRegistrati = (0, _Onboarding.useTooltipRegistration)({
    target: 'editTab',
    content: t("pc-matching:AppTabNavigation.profileTooltip"),
    position: 2,
    isFixed: true
  }),
      resetOnboarding = _useTooltipRegistrati.resetOnboarding;

  var _useContext4 = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext4.routeInternal;

  var _useContext5 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext5.isAuthenticated;

  var switchAppTab = (0, _react.useCallback)(function (tab) {
    resetOnboarding(); // Reset onboarding on tab change

    switch (tab) {
      case 'profile':
      case 'search':
      case 'jobs':
        routeInternal(tab);
        break;

      default:
        break;
    }
  }, [resetOnboarding, routeInternal]);
  var tabs = (0, _react.useMemo)(function () {
    return getTabs(t, userLikes.length, tabToAnimate, isAuthenticated, activeTab, switchAppTab, newMatches === null || newMatches === void 0 ? void 0 : newMatches.length);
  }, // To Do. Check it
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [t, userLikes.length, tabToAnimate, isAuthenticated, activeTab, switchAppTab, newMatches]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TabAnimationContext.Provider, {
    value: setAnimateTab,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabNavigation.default, {
      tabs: tabs,
      switchAppTab: switchAppTab,
      active: activeTab
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(AppTabs);

exports.default = _default;